import { Calculator } from "lucide-react";
import { fmtEur, fmtGrams, fmtMinutes, positionTotals } from "@/hooks/useKalkulation";

const nf = (v, unit) => (v === null || v === undefined || v === "" ? "–" : `${Number(v).toLocaleString("de-DE")}${unit ? ` ${unit}` : ""}`);

// Druckparameter-Karte: je kalkulierter Datei Parameter + Ergebnis. Preis = tatsächlich berechneter Positionsbetrag.
export function KalkulierteDateien({ positions }) {
  const calc = positions.filter((p) => p.kalk);
  if (!calc.length) return null;
  return (
    <div className="space-y-2" data-testid="dp-kalkulationen">
      <div className="flex items-center gap-2 text-sm font-semibold text-slate-900"><Calculator className="w-4 h-4 text-slate-500" /> Kalkulierte Dateien</div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-left uppercase tracking-wider text-slate-500 border-b border-slate-200">
              {["Pos.", "Datei", "Material / Farbe", "Stück", "Schicht", "Wände", "Infill", "Düse", "Gramm", "Druckzeit", "Preis brutto"].map((h) => <th key={h} className="py-1.5 pr-3 font-medium">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {calc.map((p) => {
              const k = p.kalk; const r = k.result || {}; const pr = k.params || {};
              const t = positionTotals(p);
              return (
                <tr key={p.id} className="border-b border-slate-100 last:border-0 align-top" data-testid={`dp-kalk-${p.id}`}>
                  <td className="py-1.5 pr-3 font-mono">{positions.indexOf(p) + 1}</td>
                  <td className="py-1.5 pr-3 break-all max-w-[220px]">{k.file_name}{r.estimated && <span className="ml-1 px-1 rounded border bg-amber-50 text-amber-800 border-amber-200">Schätzwert</span>}</td>
                  <td className="py-1.5 pr-3">{[p.material, p.farbe].filter(Boolean).join(" · ") || "–"}</td>
                  <td className="py-1.5 pr-3">{nf(pr.quantity)}</td>
                  <td className="py-1.5 pr-3">{nf(pr.layer_height, "mm")}</td>
                  <td className="py-1.5 pr-3">{nf(pr.wall_lines)}</td>
                  <td className="py-1.5 pr-3">{nf(pr.infill, "%")}</td>
                  <td className="py-1.5 pr-3">{nf(pr.nozzle_diameter, "mm")}</td>
                  <td className="py-1.5 pr-3">{fmtGrams(r.material_grams)}</td>
                  <td className="py-1.5 pr-3">{fmtMinutes(r.print_time_minutes)}</td>
                  <td className="py-1.5 pr-3 font-mono" data-testid={`dp-kalk-preis-${p.id}`}>{fmtEur(t.brutto)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
